var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":_vm.title,"append-to-body":_vm.appendToBoddy,"visible":_vm.drawer_visible,"direction":"rtl","size":"70%"},on:{"update:visible":function($event){_vm.drawer_visible=$event}}},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }